import { resaleItems } from './resource';
import type {
  CreateResaleItemPayload,
  CreateResaleItemResponse,
  UpdateResaleItemPayload,
  UpdateResaleItemResponse,
} from './types';

export async function createResaleItem(
  data: CreateResaleItemPayload,
): Promise<CreateResaleItemResponse> {
  const response = await resaleItems.create(data);
  return response.data;
}

export async function updateResaleItem(
  id: number,
  data: UpdateResaleItemPayload,
): Promise<UpdateResaleItemResponse> {
  const response = await resaleItems.update(id, data);
  return response.data;
}

export async function activateResaleItem(id: number): Promise<UpdateResaleItemResponse> {
  const response = await resaleItems.activate(id);
  return response.data;
}

export async function deactivateResaleItem(id: number): Promise<UpdateResaleItemResponse> {
  const response = await resaleItems.deactivate(id);
  return response.data;
}
